const rawMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
const GA_ID = typeof rawMeasurementId === "string" ? rawMeasurementId.trim() : "";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

let scriptInjected = false;
const hasMeasurementId = GA_ID.length > 0;

function ensureGtag() {
  if (typeof window === "undefined" || !hasMeasurementId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer!.push(arguments as unknown as Record<string, unknown>);
  };
}

export function initAnalytics() {
  if (typeof window === "undefined" || !hasMeasurementId) {
    return;
  }

  ensureGtag();

  if (document.querySelector(`script[data-ga-id="${GA_ID}"]`)) {
    window.gtag?.("config", GA_ID, { send_page_view: false });
    return;
  }

  if (scriptInjected) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.dataset.gaId = GA_ID;
  script.onload = () => {
    ensureGtag();
    window.gtag?.("js", new Date());
    window.gtag?.("config", GA_ID, { send_page_view: false });
  };
  document.head.appendChild(script);
  scriptInjected = true;
}

export function trackPageView(path: string) {
  if (typeof window === "undefined" || !hasMeasurementId) {
    return;
  }

  ensureGtag();
  window.gtag?.("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
  });
}